export default function twoPicturesAnimation() {
  const section = document.querySelector(".l-two-pictures");
  if (!section) return;

  const firstPicture = section.querySelector(".is-first-picture");
  const secondPicture = section.querySelector(".is-second-picture");

  if (section && firstPicture && secondPicture) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener("scroll", handleScroll);
          } else {
            window.removeEventListener("scroll", handleScroll);
          }
        });
      },
      { threshold: 0.1 }
    ); // Setting to start converging when 50% of the block is visible

    observer.observe(section);

    function handleScroll() {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const visibilityRatio = Math.min(
        Math.max((windowHeight - rect.top) / (windowHeight + rect.height), 0),
        1
      );

      const currentOffsetX = 60 * visibilityRatio;
      let currentOffsetY = 0;

      if (visibilityRatio >= 0.5) {
        const liftProgress = visibilityRatio - 0.5;

        currentOffsetY = liftProgress * -100;
      }

      firstPicture.style.transform = `translate(${currentOffsetX}%, ${currentOffsetY}%)`;
      secondPicture.style.transform = `translate(-${currentOffsetX}%, ${currentOffsetY}%)`;
    }
  }
}
